module.exports = __webpack_public_path__ + "img/8.85d8d1e5.jpg";